export default "__VITE_ASSET__DRUcwC5R__"